import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: ${({ theme }) => theme.COLORS.PrimaryNude};
  padding: 16px;
  border-radius: 8px;
  display: flex;
  margin-bottom: 16px;
`;
